import React, { Fragment } from "react";
import Tabs from "../../components/UI/Tabs/Tabs";
import DenContent from "./DenContent";

const Den = props => {
    return (<Fragment>
        <Tabs clicked={props.tabchange} active={props.activeTab} />
        <DenContent {...props} />
    </Fragment>);
}

export default React.memo(Den);

/**
 *             active={props.activeTab} 
            denchange={props.denchange} 
            raritychange={props.raritychange}
            nestchange={props.nestchange}
            gamechange={props.gamechange}
            eventnestchange={props.eventnestchange}
            currentDen={props.currentDen} 
            currentRarity={props.currentRarity}
            currentNest={props.currentNest}
            currentGame={props.currentGame}
            currentEventNest={props.currentEventNest}
            eventData={props.eventData}
            currentPkmn={props.currentPkmn}
            currentSelectedPokemon={props.currentSelectedPokemon}
            pokemonChange={props.pokemonChange}
 */